import { render, staticRenderFns } from "./Recordatorios.vue?vue&type=template&id=c524ba70&scoped=true"
import script from "./Recordatorios.vue?vue&type=script&lang=js"
export * from "./Recordatorios.vue?vue&type=script&lang=js"
import style0 from "./Recordatorios.vue?vue&type=style&index=0&id=c524ba70&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c524ba70",
  null
  
)

export default component.exports